module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"gender":"სქესი","male":"მამრობითი","female":"მდედრობითი","day":"დღე","month":"თვე","year":"წელი","birthdateError":"გთხოვთ შეიყვანოთ დაბადების თარიღი","genderError":"გთხოვთ აირჩიოთ სქესი"},"en":{"gender":"Gender","male":"Male","female":"Female","day":"Day","month":"Month","year":"Year","birthdateError":"Please fill your birth date","genderError":"Please fill your gender"}}')
  delete Component.options._Ctor
}
